t = require('views/internal/teacup-with-helpers')('org_export_empty')

module.exports = ->
  t.p '.quiet', { style: 'padding: 7px 0;' }, ->
    t.format 'no-exports-click-create-new-export-to-generate-a-new-one'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/org_export_empty.coffee